<template>
  <div class="content-wrapper">
    <section class="content">
      <div class="container-fluid">
        <div class="content-header mb-3">
          <h1>
            <router-link class="btn-back pc" :to="{ name: 'Home' }">
              <i class="icon-arrow-left"></i>
            </router-link>
            Back
          </h1>
        </div>

        <!-- Tab panes -->
        <div class="card bg-transparent p-0">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>

          <div id="firmwareUpdate">
            <form
              @submit.prevent="handleUpdateFirmwareSubmission()"
              method="POST"
              novalidate
            >
              <div class="row">
                <div class="col-md-4">
                  <div class="card update-firmware p-3">
                    <h3>Device Overview</h3>
                    <ul class="update-firmware-list">
                      <li>
                        <div class="update-firmware-icon">
                          <i class="icon-router pc"></i>
                        </div>
                        <div class="update-firmware-content">
                          <h4>{{ selectedRouter.deviceName }}</h4>
                          <span :class="{ pc: isAvailable > 0 }"
                            >Mac:{{ selectedRouter.mac }}</span
                          >
                        </div>
                      </li>
                      <li class="mt-3 pt-3 border-top">
                        <div class="update-firmware-icon">
                          <i class="icon-download pc"></i>
                        </div>
                        <div class="update-firmware-content">
                          <h4>
                            {{ "Latest version: " + selectedRouter.latestVersion }}
                          </h4>
                          <span :class="{ pc: isAvailable > 0 }"
                            >Current version: {{ selectedRouter.currentVersion }}</span
                          >
                          <span>Release date: {{ selectedRouter.releaseDate }}</span>
                          <a
                            target="_blank"
                            href="https://help.audrasecurity.com/knowledge/Release-Notes"
                            >View Release Notes</a
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="card update-firmware p-3">
                    <h3>Firmware Update</h3>
                    <div v-if="shouldShowRouterList" class="mb-3 required">
                      <label class="control-label">Select Router for Update</label>
                      <multiselect
                        v-model="selectedRouter"
                        :options="routerList"
                        :custom-label="(opt) => opt.deviceName"
                        placeholder="Select Audra Name"
                        :searchable="true"
                        :multiple="false"
                        id="accountId"
                        v-bind:class="{ 'has-error': errors.has('accountId') }"
                        v-validate="'required'"
                        name="accountId"
                        @input="routerSwitch"
                      >
                      </multiselect>
                      <div class="help text-danger" v-show="errors.has('accountId')">
                        {{ errors.first("accountId") }}
                      </div>
                    </div>

                    <div class="d-none error-message" v-if="pandingChangeLog > 0">
                      Please wait. The Firewall update is in processing.
                      <div class="firewall-progress my-3">
                        <div class="firewall-progress-percent" style="width: 35%">
                          35%
                        </div>
                      </div>
                    </div>
                    <button
                      v-if="!selectedRouterData.isAvailable"
                      type="submit"
                      class="btn mt-3 w-100 py-3 fw-500 mb-3 d-none"
                      :disabled="isSubmit || disableSubmitButton"
                    >
                      No Update Available
                    </button>

                    <div v-if="!selectedRouterData.isAvailable" class="uptodate">
                      <h4>
                        <i class="fa fa-check-circle pc" aria-hidden="true"></i>Your
                        device is up to date and is running on the latest version.
                      </h4>
                    </div>
                    <div v-else class="uptodate">
                      <h4>
                        <i class="icon-audra pc"></i>A new firmware update is available!
                      </h4>
                      <p class="mb-0">
                        This update includes security patches, performance improvements,
                        and new features.
                      </p>
                      <button type="submit" class="btn mt-3 w-100 py-3 fw-500">
                        {{ isSubmit ? "Please Wait..." : "Update Firmware Now" }}
                      </button>
                    </div>

                    <div class="update-info d-none">
                      <p>
                        Audra is committed to keeping all devices secure and working with
                        the latest features according to the established best practices by
                        providing firmware updates within the support time, which include
                        security updates, bug fixes and new functions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";

export default {
  name: "UpdateConfiguration",
  metaInfo: {
    title: "Administrator Settings | Dotlines",
  },
  components: {},
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    old_password: "",
    password: "",
    password_confirmation: "",
    showOldPassword: false,
    showPassword: false,
    showConfirmPassword: false,
    isSubmit: false,
    params: {},
    value: {},
    notificationSettingValue: {},
    timeZoneValue: {},
    accountId: "",
    pre: {},

    pandingChangeLog: 0,
    isAvailable: 0,
    zone_time: "",
    users: [],
    inputs: {},
    routerList: [
      {
        deviceName: "safehome",
        accountId: 434,
        deviceType: "Audra_Safe_30",
        currentVersion: "5.0.1",
        latestVersion: "5.0.3",
        mac: "",
        releaseDate: "",
      },
    ],

    selectedRouterData: {
      accountId: LocalStorage.get("accountId"),
      deviceName: LocalStorage.get("deviceName"),
      deviceType: LocalStorage.get("deviceType"),
      currentVersion: LocalStorage.get("version"),
      latestVersion: LocalStorage.get("latestVersion"),
      mac: LocalStorage.get("mac"),
      releaseDate: LocalStorage.get("releaseDate"),
      isAvailable: false,
    },
  }),

  methods: {
    handleUpdateFirmwareSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.isSubmit = true;
          _this.$swal
            .fire({
              title: "Are you sure to update firmware?",
              text: "",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Yes",
            })
            .then((result) => {
              if (result.isConfirmed) {
                _this.isSubmit = true;
                axios
                  .post("/updateFirmware", {
                    accountId: _this.selectedRouterData.accountId,
                    version: _this.selectedRouterData.latestVersion,
                  })
                  .then((response) => {
                    _this.$toaster.success(response.data.message);
                  })
                  .catch((error) => {
                    console.log(error);
                    _this.$swal.fire("Failed!", "failed to reboot.", "error");
                  })
                  .finally(() => {
                    _this.isSubmit = false;
                  });
              }
            });
        }
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await CommonAPI.getVersionList(LocalStorage.get("accountId"))
        .then((response) => {
          this.routerList = response;
          const initialRouter =
            this.routerList.find(
              (router) => router.accountId === this.selectedRouterData.accountId
            ) || this.selectedRouterData;

          this.selectedRouterData.isAvailable =
            this.versionToInt(initialRouter.latestVersion) >
            this.versionToInt(initialRouter.currentVersion);
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;

      this.updateLayout();
      $(window).resize(() => {
        this.updateLayout();
      });
    },
    routerSwitch(newRouter) {
      this.isSwitching = true;
      const routerList = this.routerList || [];
      const router = routerList.find(
        (router) => router.accountId === newRouter.accountId
      ) || {
        accountId: 0,
        deviceName: "Router",
        currentVersion: "0.0.0.0",
        latestVersion: "0.0.0.0",
        deviceType: "MT",
      };
      const isAvailable =
        this.versionToInt(router.latestVersion) >
        this.versionToInt(router.currentVersion);

      this.selectedRouterData = {
        accountId: router.accountId,
        deviceName: router.deviceName,
        deviceType: router.deviceType,
        currentVersion: router.currentVersion,
        latestVersion: router.latestVersion,
        isAvailable: isAvailable,
      };

      this.isSwitching = false;
    },
    updateLayout() {
      if ($(window).width() < 800) {
        const tab_pane = $(".tab-pane");
        tab_pane.removeClass("tab-pane active").addClass("collapse");
      } else {
        const tab_pane = $(".tab-pane");
        tab_pane.removeClass("collapse show").addClass("tab-pane");
        $(".default").addClass("active");
      }
    },
    validateFields(fieldNames) {
      const fieldValidationPromises = [];

      fieldNames.forEach((fieldName) => {
        const promise = this.$validator.validate(fieldName);
        fieldValidationPromises.push(promise);
      });

      return Promise.all(fieldValidationPromises)
        .then((results) => {
          if (results.includes(false)) {
            return false;
          } else {
            return true;
          }
        })
        .catch((error) => {
          console.error("Validation error:", error);
          return false;
        });
    },
    versionToInt(version) {
      return version.split(".").reduce((acc, num) => acc * 100 + parseInt(num), 0);
    },
  },

  computed: {
    disableSubmitButton() {
      /* return this.pre.newVesion <= this.pre.curVesion; */
      return true;
    },
    selectedRouter: {
      get() {
        return this.selectedRouterData;
      },
      set(newValue) {
        this.selectedRouterData = newValue;
      },
    },
    shouldShowRouterList() {
      return this.routerList.length > 1;
    },
  },

  watch: {
    selectedRouter: {
      handler(newVal) {
        this.newRouterName = newVal.deviceName || "Default Router Name";
      },
      deep: true,
    },
  },

  mounted() {
    this.initialize();
  },
};
</script>

<style scoped></style>
